import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';
import { H3, P } from 'shared-assets/components/Elements';
import rollbar from 'shared-assets/src/errors/errors';
import TelehealthLogo from 'shared-assets/talking-parrot-ui/components/TelehealthLogo';
import LayoutCentered from './LayoutCentered';
var BrowserSupport = function () {
    useEffect(function () {
        rollbar.info('User loaded Telehealth UI with a unsupported browser');
    }, []);
    return (React.createElement(LayoutCentered, null,
        React.createElement(TelehealthLogo, null),
        React.createElement(Card, { style: { width: '100%' } },
            React.createElement(CardContent, null,
                React.createElement(Grid, { item: true },
                    React.createElement(H3, null, "Browser Not Supported"),
                    React.createElement(P, { style: { padding: 0 } }, "Please try again using a supported mobile browser:"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Safari (iOS 13.1 or later)"),
                        React.createElement("li", null, "Chrome (iOS 14.5 or later)")))))));
};
export default BrowserSupport;
